<template>
  <BForm
    class="formulario"
    @submit.prevent="gravar">
    <InputBasico
      ref="inputCodigo"
      type="text"
      name="nomeInput"
      label="Código*"
      class="input__codigo"
      v-model="form.codigo"
      v-validate="'required|min:3'"
      :errorsBag="errors"
      :upperCase="true"
    />

    <InputBasico
      type="text"
      name="nomeInput"
      label="Nome*"
      class="input__nome"
      v-model="form.nome"
      v-validate="'required|min:3'"
      :errorsBag="errors"
    />

    <InputDescricao
      name="descricaoInput"
      label="Descrição"
      class="input__descricao"
      v-model="form.descricao"
      :rows="5"
    />

    <div class="botao__container">
      <BButton
        type="submit"
        class="botao"
        variant="primary">
        Gravar
      </BButton>

      <BButton
        @click.prevent="sair"
        class="botao"
        variant="outline-primary">
        Sair
      </BButton>
    </div>
  </BForm>
</template>

<script>
import { BForm, BButton } from 'bootstrap-vue/es/components'

import FormularioCadastroMixin from '@/mixins/FormularioCadastroMixin'
import InputBasico from '@/components/inputs/InputBasico.vue'
import InputDescricao from '@/components/inputs/InputDescricao.vue'

export default {
  name: 'UsuariosCadastroForm',
  mixins: [FormularioCadastroMixin],
  components: {
    BForm,
    BButton,
    InputBasico,
    InputDescricao,
  },
  mounted() {
    this.$refs.inputCodigo.focar()
  },
  methods: {
    valoresIniciaisForm() {
      return {
        status: true,
        codigo: '',
        nome: '',
        descricao: '',
      }
    },
    retornaCamposGravar() {
      return this.form
    },
    limpar() {
      this.form = this.valoresIniciaisForm()
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

.formulario {
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: $small-size) {
    width: 100%;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 0.8em;
  }

  @media (min-width: $extra-large-size) {
    width: $medium-size;
  }
}

.input {
  &__ativo {
    @media (min-width: $small-size) {
      grid-column: 1 / 4;
    }
  }

  &__codigo {
    @media (min-width: $small-size) {
      grid-column: 1 / 4;
    }
  }

  &__nome {
    @media (min-width: $small-size) {
      grid-column: 4 / -1;
    }
  }

  &__descricao {
    @media (min-width: $small-size) {
      grid-column: 1 / -1;
    }
  }
}

.botao {
  margin-left: .2rem;

  &__container {
    margin-top: 1rem;
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
}

</style>
